import BR from "./BR.png";
import DE from "./DE.png";
import EN from "./EN.png";
import ES from "./ES.png";
import FI from "./FI.png";
import HU from "./HU.png";
import NO from "./NO.png";
import SE from "./SE.png";
import UK_ONLY from "./UK_ONLY.png";
import PROMO50 from "./PROMO50.png";
import PROMO100 from "./PROMO100.png";
import sportDefaultBet from "./sportDefaultBet.png";
import sportDefaultSpins from "./sportDefaultSpins.png";
import sportUKbet from "./sportUKbet.png";
import sportUKspins from "./sportUKspins.png";
import sportNZbet from "./sportNZbet.png";
import sportNZspins from "./sportNZspins.png";
import sportZAbet from "./sportZAbet.png";
import sportZAspins from "./sportZAspins.png";
import sportPEbet from "./sportPEbet.png";
import sportPEspins from "./sportPEspins.png";
import sportCLbet from "./sportCLbet.png";
import sportCLspins from "./sportCLspins.png";
import sportNObet from "./sportNObet.png";
import sportNOspins from "./sportNOspins.png";

import B10G30S15BetUK from "./B10G30S15BetUK.png";
import B10G30S15SpinsUK from "./B10G30S15SpinsUK.png";
import B10G30S15BetMGA from "./B10G30S15BetMGA.png";
import B10G30S15SpinsMGA from "./B10G30S15SpinsMGA.png";

import B20G20S20BetUK from "./B20G20S20BetUK.png";
import B20G20S20SpinsUK from "./B20G20S20SpinsUK.png";

import B15G20S55BetUK from "./B15G20S55BetUK.png";
import B15G20S55SpinsUK from "./B15G20S55SpinsUK.png";

import UK_50_MATCH_UP_1 from "./UK_50_MATCH_UP_1.png";
import UK_50_MATCH_UP_2 from "./UK_50_MATCH_UP_2.png";
import UK_35_MATCH_UP_1 from "./UK_35_MATCH_UP_1.png";
import UK_35_MATCH_UP_2 from "./UK_35_MATCH_UP_2.png";
import UK_25_MATCH_UP_1 from "./UK_25_MATCH_UP_1.png";
import UK_25_MATCH_UP_2 from "./UK_25_MATCH_UP_2.png";
import Promo20spins from "./Promo20spins.png";
import Promo200spins from "./Promo200spins.png";
import PromoUpTo100GB from "./PromoUpTo100GB.png";
import PromoUpTo100default from "./PromoUpTo100default.png";
import PromoUpto1500GB from "./PromoUpto1500GB.png";
import PromoUpto1500default from "./PromoUpto1500default.png";
import UpTo200 from "./UpTo200.png";
import UpTo200spins from "./UpTo200spins.png";
import Promo100UpTo1650NZ from "./Promo100UpTo1650NZ.png";
import Spins300 from "./Spins300.png";
import Promo100UpTo100_DK from "./Promo100UpTo100_DK.png";
import Promo100UpTo150Plus15_UK_Spins from "./Promo100UpTo150Plus15_UK_Spins.png";
import Promo100UpTo150Plus15_UK_Bet from "./Promo100UpTo150Plus15_UK_Bet.png";
import Promo100UpTo150Plus15_MGA_Spins from "./Promo100UpTo150Plus15_MGA_Spins.png";
import Promo100UpTo150Plus15_MGA_Bet from "./Promo100UpTo150Plus15_MGA_Bet.png";

export const imgLib = {
  BR,
  DE,
  ES,
  FI,
  HU,
  NO,
  SE,
  EN,
  UK_ONLY,
  PROMO50,
  PROMO100,
  Promo200spins,
  SPORT_MGA_1: sportDefaultBet,
  SPORT_MGA_2: sportDefaultSpins,
  SPORT_UK_1: sportUKbet,
  SPORT_UK_2: sportUKspins,
  SPORT_GB_1: sportUKbet,
  SPORT_GB_2: sportUKspins,
  SPORT_NZ_1: sportNZbet,
  SPORT_NZ_2: sportNZspins,
  SPORT_ZA_1: sportZAbet,
  SPORT_ZA_2: sportZAspins,
  SPORT_PE_1: sportPEbet,
  SPORT_PE_2: sportPEspins,
  SPORT_CL_1: sportCLbet,
  SPORT_CL_2: sportCLspins,
  SPORT_NO_1: sportNObet,
  SPORT_NO_2: sportNOspins,
  MATCHUP_200_1: UpTo200,
  MATCHUP_200_2: UpTo200spins,
  uk50matchup_1: UK_50_MATCH_UP_1,
  uk50matchup_2: UK_50_MATCH_UP_2,
  uk35matchup_1: UK_35_MATCH_UP_1,
  uk35matchup_2: UK_35_MATCH_UP_2,
  uk25matchup_1: UK_25_MATCH_UP_1,
  uk25matchup_2: UK_25_MATCH_UP_2,
  Promo20spins_upto100GB_1: PromoUpTo100GB,
  Promo20spins_upto100GB_2: Promo20spins,
  Promo20spins_upto100default_1: PromoUpTo100default,
  Promo20spins_upto100default_2: Promo20spins,
  PromoUpto1500GB_1: PromoUpto1500GB,
  PromoUpto1500GB_2: Promo200spins,
  PromoUpto1500default_1: PromoUpto1500default,
  PromoUpto1500default_2: Promo200spins,
  Promo100UpTo1650NZ_1: Promo100UpTo1650NZ,
  Promo100UpTo1650NZ_2: Spins300,
  Promo100UpTo150Plus15_UK_1: Promo100UpTo150Plus15_UK_Bet,
  Promo100UpTo150Plus15_UK_2: Promo100UpTo150Plus15_UK_Spins,
  Promo100UpTo150Plus15_MGA_1: Promo100UpTo150Plus15_MGA_Bet,
  Promo100UpTo150Plus15_MGA_2: Promo100UpTo150Plus15_MGA_Spins,
  Promo100UpTo100_DK: Promo100UpTo100_DK,
  B10G30S15_UK_1: B10G30S15BetUK,
  B10G30S15_UK_2: B10G30S15SpinsUK,
  B10G30S15_MGA_1: B10G30S15BetMGA,
  B10G30S15_MGA_2: B10G30S15SpinsMGA,
  B20G20S20_UK_1: B20G20S20BetUK,
  B20G20S20_UK_2: B20G20S20SpinsUK,
  B15G20S55_UK_1: B15G20S55BetUK,
  B15G20S55_UK_2: B15G20S55SpinsUK,
};
